import { render } from "./DefaultObjField.vue?vue&type=template&id=46618169"
import script from "./DefaultObjField.vue?vue&type=script&lang=js"
export * from "./DefaultObjField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__